import { Box } from '@mantine/core';
import type { HTMLAttributes } from 'react';

export function ResizeHandle({
	dragging,
	direction,
	children,
	className,
	...props
}: {
	dragging: boolean;
	direction: 'left' | 'right';
} & HTMLAttributes<HTMLDivElement>) {
	return (
		<Box
			sx={(theme) => ({
				cursor: 'ew-resize',
				position: 'absolute',
				left: direction === 'left' ? '-4px' : 'initial',
				right: direction === 'right' ? '-4px' : 'initial',
				top: '30%',
				bottom: '30%',
				width: '8px',
				userSelect: 'none',
				opacity: dragging ? 1 : 0,
				transition: 'opacity 150ms ease-in-out',

				'&:after': {
					content: '""',
					position: 'absolute',
					left: direction === 'left' ? '8px' : 'initial',
					right: direction === 'right' ? '8px' : 'initial',
					top: '50%',
					transform: 'translateY(-50%)',
					width: '6px',
					height: '25%',
					minHeight: '20px',
					borderRadius: '4px',
					background: theme.other.getColor('fill/secondary/default'),
					boxShadow: `0 0 0 1px ${theme.other.getColor('text/secondary/default')}`,
					opacity: 0.75,
				},

				'@media print': {
					display: 'none',
				},
			})}
			{...props}
			className={`resize-handle ${className}`}
		>
			{children}
		</Box>
	);
}
